// Secure localStorage utilities - tokens are now handled via httpOnly cookies
export const user = () => {
  try {
    return JSON.parse(localStorage.getItem("user"));
  } catch (error) {
    console.error('Error parsing user from localStorage:', error);
    return null;
  }
};

export const customer = () => {
  try {
    return JSON.parse(localStorage.getItem("customer"));
  } catch (error) {
    console.error('Error parsing customer from localStorage:', error);
    return null;
  }
};

export const defaultStation = () => {
  try {
    return JSON.parse(localStorage.getItem("defaultStation"));
  } catch (error) {
    console.error('Error parsing defaultStation from localStorage:', error);
    return null;
  }
};

// DEPRECATED: Tokens are now handled via secure httpOnly cookies
// This function is kept for backward compatibility but returns null
export const token = () => {
  console.warn('SECURITY WARNING: token() is deprecated. Tokens are now handled via secure httpOnly cookies.');
  return null;
};

// Secure storage helpers
export const setUser = (userData) => {
  try {
    // Remove sensitive data before storing
    const sanitizedUser = { ...userData };
    delete sanitizedUser.password;
    delete sanitizedUser.token;

    localStorage.setItem("user", JSON.stringify(sanitizedUser));
    // Same-tab components that read user()/permissions fresh on every render
    // (Sidebar, PermittedRoute, per-page permission gates) have no way to know
    // this changed otherwise — the browser's own "storage" event only fires in
    // OTHER tabs, never the tab that made the write. See hooks/useUserRefreshTick.js.
    window.dispatchEvent(new Event("user-profile-updated"));
  } catch (error) {
    console.error('Error storing user data:', error);
  }
};

export const setCustomer = (customerData) => {
  try {
    // Remove sensitive data before storing
    const sanitizedCustomer = { ...customerData };
    delete sanitizedCustomer.password;
    delete sanitizedCustomer.token;
    
    localStorage.setItem("customer", JSON.stringify(sanitizedCustomer));
  } catch (error) {
    console.error('Error storing customer data:', error);
  }
};

export const setDefaultStation = (stationData) => {
  try {
    localStorage.setItem("defaultStation", JSON.stringify(stationData));
  } catch (error) {
    console.error('Error storing defaultStation data:', error);
  }
};

// Clear all stored data
export const clearAll = () => {
  localStorage.removeItem("user");
  localStorage.removeItem("customer");
  localStorage.removeItem("defaultStation");
  localStorage.removeItem("token"); // Clear deprecated token storage
};

// Check if user is authenticated (basic check - real auth is handled server-side)
export const isAuthenticated = () => {
  const userData = user();
  const customerData = customer();
  return !!(userData || customerData);
};
